'use client'

import { Mic } from 'lucide-react'
import * as React from 'react'
import { PluginComponent } from 'react-markdown-editor-lite'

import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

interface MarkdownAudioPhraseToolbarPluginConfig {
  onAttach?: () => void
}

const AUDIO_PHRASE_TOOLTIP =
  'Open the audio dialog to attach phrase audio or section audio. Bold (Ctrl+B) uses the same dialog.'

class MarkdownAudioPhraseToolbarPlugin extends PluginComponent {
  render() {
    const onAttach = this.getConfig('onAttach') as MarkdownAudioPhraseToolbarPluginConfig['onAttach']

    return (
      <span className="button button-type-audio-phrase">
        <TooltipProvider delayDuration={200}>
          <Tooltip>
            <TooltipTrigger asChild>
              <Button
                type="button"
                variant="outline"
                size="sm"
                className="h-7 gap-1 px-2 text-xs"
                onClick={onAttach}
              >
                <Mic className="size-3.5" />
                Attach audio
              </Button>
            </TooltipTrigger>
            <TooltipContent side="bottom" align="end" className="max-w-xs text-left">
              {AUDIO_PHRASE_TOOLTIP}
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </span>
    )
  }
}

MarkdownAudioPhraseToolbarPlugin.pluginName = 'audio-phrase-attach'
MarkdownAudioPhraseToolbarPlugin.align = 'right'

export default MarkdownAudioPhraseToolbarPlugin
